import Avatar from '@mui/material/Avatar';
import React, {FC} from "react";

type PropsType = {
  src: string;
  name: string;
}

const CustomAvatar: FC<PropsType> = ({src, name}) => {

  const stringToColor = (string: string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  const stringAvatar = (str: string) => {
    const strToArr = str.split(' ').slice(0, 2)

    return {
      // sx: {
      //   bgcolor: stringToColor(str),
      // },
      children: `${strToArr.map((i) => i[0]).join('')}`,
    };
  }

  return (
    <Avatar {...stringAvatar(name)} src={src} alt="Avatar" />
  )
}

export default CustomAvatar